import { render, staticRenderFns } from "./invoice-text.vue?vue&type=template&id=20b3bd68&"
import script from "./invoice-text.vue?vue&type=script&lang=js&"
export * from "./invoice-text.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports